import { render, staticRenderFns } from "./trainingDaYing.vue?vue&type=template&id=20b16326&scoped=true&"
import script from "./trainingDaYing.vue?vue&type=script&lang=js&"
export * from "./trainingDaYing.vue?vue&type=script&lang=js&"
import style0 from "./trainingDaYing.vue?vue&type=style&index=0&id=20b16326&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b16326",
  null
  
)

export default component.exports